import React, { useEffect, useState, useCallback, FC } from 'react';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import KeycloakState from '../../auth/KeycloakState';

type User = { name: string; email: string; id: string } | null;

interface Props {
    keycloakState: KeycloakState;
}

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        welcome: {
            flexGrow: 1,
        },
    }),
);

const UserInfo: FC<Props> = (props) => {
    const classes = useStyles();

    const keycloakState = props.keycloakState;
    const [user, setUser] = useState<User>();

    const loadUserInfo = useCallback(() => {
        if (keycloakState.keycloak === null) {
            throw Error('keycloak is not initialized.');
        }
        keycloakState.keycloak.loadUserInfo().success((user: any) => {
            setUser({ name: user.preferred_username, email: user.email, id: user.sub });
        });
    }, [keycloakState]);

    useEffect(() => {
        loadUserInfo();
    }, [loadUserInfo]);

    return (
        <div className="UserInfo">
            <Typography variant="body2" className={classes.welcome}>
                Welcome <b>{user != null ? user.name : ''}</b>
            </Typography>
        </div>
    );
};

export default UserInfo;
